import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CookieService } from 'src/app/core/services/cookie.service';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';
import { ViewLoginReportComponent } from '../view-login-report/view-login-report.component';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-login-report',
  templateUrl: './login-report.component.html',
  styleUrls: ['./login-report.component.scss']
})
export class LoginReportComponent implements OnInit {
  

  public daterange: any = {};
  selectedReportBy: string = 'last30days';
  dtOptions: DataTables.Settings = {};
  dtOptions1: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  dateRangeValue:string;
  dates: { endDate: string; startDate: string; };
  Start: string;
  end: string;
  startDate:string;
  endDate: string
  UserId: string;


  constructor(private datepipe: DatePipe,private gs: GeneralService,private http: HttpClient,  private dialog: MatDialog) { }

  ngOnInit() {
    const today = new Date();
    const endDate = today.toISOString().split('T')[0]; // Current date as end date

    // Calculate start date as 30 days ago
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 30);
    const startDateFormatted = startDate.toISOString().split('T')[0];

    this.dates = { endDate: endDate, startDate: startDateFormatted };
    this.dateRangeValue = startDateFormatted + '-' + endDate; 
    this.Start = this.dates.startDate;
    this.end = this.dates.endDate
    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      processing: true,
      serverSide: true,
      // ordering: true,
      searching: true,
      order: [[0, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        this.http
          .get<DataTablesResponse>(

            `${this.gs.loginReport()}` + `?endDate=${this.dates.endDate}` + `&startDate=${this.dates.startDate}` +
            `${dataTablesParameters.length.value != '' ? '&Records=' + dataTablesParameters.length : ''}` +
             `&PageNO=${((dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length)}`
             +  `${dataTablesParameters.search.value != '' ? '&name=' + dataTablesParameters.search.value : ''}`

          )
          .subscribe((resp: any) => {
            console.log('res',resp.counts)
            callback({
              recordsTotal: resp.counts[0].counts,
              recordsFiltered: resp.counts[0].counts ,
              data: resp.data,
            });
            
          });
      },
      columns: [

        {
          title: "UserId",
          data: null,
          render: (data) => {
            return data.id
          },
        },
        {
          title: "Name",
          data: null,
          render: (data) => {
            return data.Name ? data.Name : "--";
          },
        },
        {
          title: "MobileNo.",
          data: null,
          render: (data) => {
            return data.mobileno ? data.mobileno : "--";
          },
        },
        {
          title: "Email",
          data: null,
          render: (data) => {
            return data.email ? data.email : "--";
          },
        },
        {
          title: "Plan Type",
          data: null,
          render: (data) => {
            return data.plan_name ? data.plan_name : "--";
          },
        },
        {
          title: "Status",
          data: null,
          render: (data) => {
            return data.status ? data.status : "--";
          },
        },
        {
          title: 'Last Login Date',
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.login_date, 'dd-MM-yyyy');
          },
        },
        {
          title: 'Last Login Time',
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.login_date, 'HH:mm:ss');
          },
        },
       
        {
          title: "Login History",
          data: null,
          render: (data) => { 
            
            return `<a style='cursor: pointer' class="view" UserID="${data.id}" title="View Report">${data.login_count ? data.login_count : '--'}</a>`
          },
        },

      ],
      drawCallback: () => {
        $('.view').on('click', (e) => {
          this.UserId = e.target.getAttribute('UserID')
          console.log('UserID',this.UserId)
          this.openDialog();
        });
      
      },
    };
  }
  openDialog(){
    const dialogRef = this.dialog.open(ViewLoginReportComponent, {
      width: '600px',
      autoFocus: false,
      maxHeight: '90vh',
      disableClose: true,
      data:{
        UserID: this.UserId,
        StartDate: this.Start,
        EndDate: this.end
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.rerender();
      }
    });
  }
  onReportByChange(value: string) {
    console.log('Vuidc',value)
    this.selectedReportBy = value;
    const today = new Date();
    const endDate = today.toISOString().split('T')[0];
    if(this.selectedReportBy === undefined){
      const startDate = new Date();
    startDate.setDate(startDate.getDate() - 30);
    const startDateFormatted = startDate.toISOString().split('T')[0];

    this.dates = { endDate: endDate, startDate: startDateFormatted };
    this.dateRangeValue = startDateFormatted + ' To ' + endDate;
    this.Start = this.dates.startDate;
    this.end = this.dates.endDate
    this.selectedReportBy = 'last30days'
    }
    

     // Current date as end date
  if (value === 'last30days') {

    // Calculate start date as 30 days ago
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 30);
    const startDateFormatted = startDate.toISOString().split('T')[0];

    this.dates = { endDate: endDate, startDate: startDateFormatted };
    this.dateRangeValue = startDateFormatted + ' To ' + endDate;
    this.Start = this.dates.startDate;
    this.end = this.dates.endDate
  }
  this.rerender()
  }
  ngAfterViewInit() {
    this.dtTrigger.next();
  }
  datechange(){
    let dateRange =document.getElementById('daterangeInput');
   
    if(dateRange){
      dateRange.click()
    }
  
  }
  selectedstartDate(event: Event){
    this.startDate = (event.target as HTMLInputElement).value;

    // this.startDate = this.dates.startDate
    console.log('Start date',this.startDate)
  }
  selectedendDate(event: Event){
    this.endDate = (event.target as HTMLInputElement).value;
    let Enddate = new Date(this.endDate)
    const formattedEndDate = `${Enddate.getFullYear()}-${(Enddate.getMonth() + 1).toString().padStart(2, '0')}-${Enddate.getDate().toString().padStart(2, '0')}`;

    console.log('end date',this.endDate)
    
  }
  selectedDate(value: any) {
    console.log('value date',value)
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    let startDate = new Date( this.daterange.start );
    let endDate = new Date(this.daterange.end );
    const formattedStartDate = `${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`; 
    const formattedEndDate = `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`;
    // this.getCalenderType(this.daterange);
    let dates = { endDate: formattedEndDate, startDate: formattedStartDate };
    this.dates = dates;
    console.log('date',this.dates)
    this.dateRangeValue = formattedStartDate + ' To ' + formattedEndDate
    this.Start = this.dates.startDate;
    this.end = this.dates.endDate
    this.rerender()
    
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
